// The website dashboard's own address (components/InsightsPage), linked from nowhere.
export const INSIGHTS_PATH = '/insights'

export function isInsightsPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === INSIGHTS_PATH
}
